import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, ArrowRight } from 'lucide-react';
import { Button } from '../../components/ui/button';

/**
 * Settings → Automations (Deprecated)
 * 
 * This page has been replaced by the first-class Playbooks module.
 * Shows a migration notice directing users to /playbooks.
 */
const Automations = () => {
  return (
    <div className="max-w-2xl mx-auto py-12 px-6">
      <div className="text-center space-y-6">
        {/* Icon */}
        <div className="w-16 h-16 rounded-full bg-[rgba(242,107,29,0.1)] flex items-center justify-center mx-auto">
          <Zap className="w-8 h-8 text-[var(--cb-orange)]" />
        </div>

        {/* Title */}
        <div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Automations Have Moved
          </h1>
          <p className="text-gray-600">
            Automations are now managed in the new <strong>Playbooks</strong> module.
          </p>
        </div>

        {/* Description */}
        <div className="bg-gray-50 rounded-xl p-6 text-left space-y-3">
          <p className="text-sm text-gray-700">
            <strong>What's new:</strong>
          </p>
          <ul className="text-sm text-gray-600 space-y-2">
            <li className="flex items-start gap-2">
              <span className="text-[var(--cb-orange)]">✓</span>
              <span>First-class sidebar module (no longer buried in Settings)</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[var(--cb-orange)]">✓</span>
              <span>New action: Send SMS automatically when events happen</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[var(--cb-orange)]">✓</span>
              <span>Step-by-step playbook builder with live preview</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[var(--cb-orange)]">✓</span>
              <span>Safeguards: Business hours, once-per-lead, no-reply filters</span>
            </li>
          </ul>
        </div>

        {/* CTA */}
        <Link to="/playbooks">
          <Button
            className="text-white"
            style={{ backgroundColor: 'var(--cb-orange)' }}
            size="lg"
          >
            Go to Playbooks
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </Link>

        {/* Note */}
        <p className="text-xs text-gray-500">
          Your existing automations have been preserved and are available in Playbooks.
        </p>
      </div>
    </div>
  );
};

export default Automations;
